import { gql } from '@apollo/client';

export * from './softwareEscrowActivate.mutation.generated';

export const SOFTWARE_ESCROW_ACTIVATE = gql`
  mutation softwareEscrowActivate($softwareEscrowId: ID!) {
    softwareEscrowActivate(input: { softwareEscrowId: $softwareEscrowId }) {
      success
      errors
    }
  }
`;
